import {
  HeadingText,
  ParagraphText,
  Modal,
  ImageMessage,
  useMediaQuery,
  queryHelpers,
} from '@leagueplatform/genesis-core';
import { useIntl } from '@leagueplatform/locales';
import errorImg from 'assets/remove-warning.svg';
import { BaseModalContainer } from 'components/modals/common/base-modal.component';
import { PRODUCT_AREA } from '@leagueplatform/analytics';
import {
  ANALYTICS_SCREEN_NAMES,
  DETAIL,
} from '@telus-alberta-health-web/shared-module';
import { ModalActionButton } from './common/modal-action-button.component';

export const AccountDeletedModal = () => {
  const { formatMessage } = useIntl();
  const isMobile = useMediaQuery(queryHelpers.only('mobile'));

  return (
    <BaseModalContainer
      footer={
        <ModalActionButton
          actionType="submit"
          buttonText={formatMessage({ id: 'STR_I_UNDERSTAND' })}
          isMobile={isMobile}
          css={{
            background: '$interactiveActionPrimary',
            alignSelf: 'flex-end',
            marginBlockStart: '$two',
          }}
          trackAnalytics={{
            product_area: PRODUCT_AREA.SETTINGS,
            screen_name: ANALYTICS_SCREEN_NAMES.DELETION_CONFIRMATION,
            detail: DETAIL.ACKNOWLEDGE_DELETION,
          }}
        />
      }
    >
      <ImageMessage image={errorImg} css={{ flexGrow: 1, textAlign: 'left' }}>
        <Modal.Title>
          <HeadingText level="2" size="lg" css={{ marginBlock: '$one' }}>
            {formatMessage({ id: 'STR_ACCOUNT_DELETED_HEADING' })}
          </HeadingText>
        </Modal.Title>
        <ParagraphText>
          {formatMessage({ id: 'STR_ACCOUNT_DELETED_BODY_1' })}
        </ParagraphText>
      </ImageMessage>
    </BaseModalContainer>
  );
};
